/* eslint-disable jsx-a11y/anchor-is-valid */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router";
import {
  AppleAppStore,
  GooglePlayStore,
  lightLogoImg,
  LogoImg,
} from "../Constants/Images";
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faPinterestP,
  faTiktok,
  faXTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <>
      <div className="footer-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-xs-6">
              <div className="about-website-description">
                <img src={lightLogoImg} alt="" />

                <p>
                  We bring people together — with less hassle and more heart.
                </p>
              </div>
            </div>

            <div className="col-md-3 col-xs-6">
              <h3>Explore</h3>
              <ul>
                <li>
                  <Link to="/search">Find a Space</Link>
                </li>
                <li>
                  <Link to="/user/venues">List Your Space</Link>
                </li>
                <li>
                  <a href="https://getspacii.com/" target="_blank">
                    Our Community
                  </a>
                </li>
                <li>
                  <Link to="/ambassador-program">Ambassador Program</Link>
                </li>
              </ul>
            </div>

            <div className="col-md-3 col-sm-4 col-xs-6">
              <h3>Support</h3>
              <ul>
                <li>
                  <Link to="/about">Help Center</Link>
                </li>
                <li>
                  <Link to="/careers">Terms & Conditions</Link>
                </li>
                <li>
                  <Link to="/careers">Privacy Policy</Link>
                </li>
              </ul>
            </div>

            <div className="col-md-3 col-xs-6">
              <h3>Stay Connected</h3>
              <div className="social-accounts">
                <ul>
                  <li>
                    <a href="#" target="_blank">
                      <FontAwesomeIcon icon={faFacebookF} color="#ffffff" />
                    </a>
                  </li>
                  <li>
                    <a href="#" target="_blank">
                      <FontAwesomeIcon icon={faInstagram} color="#ffffff" />
                    </a>
                  </li>
                  <li>
                    <a href="#" target="_blank">
                      <FontAwesomeIcon icon={faXTwitter} color="#ffffff" />
                    </a>
                  </li>
                  <li>
                    <a href="#" target="_blank">
                      <FontAwesomeIcon icon={faLinkedinIn} color="#ffffff" />
                    </a>
                  </li>
                  {/* <li>
                  <a href="#" target="_blank">
                    <FontAwesomeIcon icon={faPinterestP} color="#ffffff" />
                  </a>
                </li> */}
                  <li>
                    <a href="#" target="_blank">
                      <FontAwesomeIcon icon={faTiktok} color="#ffffff" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-big-text">Spacii</div>
      </div>
    </>
  );
};

export default Footer;
